import { useDocumentTitle } from "../hooks/useDocumentTitle";

/**
 * DocumentTitle
 * Keeps the browser tab title as `DQ | <Page Name>` for the active route
 * (DQ-8736). Mounted once inside the router alongside PathTracker so the
 * location subscription is isolated here rather than re-rendering the whole
 * route tree. Renders nothing.
 */
const DocumentTitle: React.FC = () => {
  useDocumentTitle();

  return null;
};

export default DocumentTitle;
